import React, { useState, useEffect } from 'react';
import './CourseIntergrate.css';
import DynamicBanner from '../../Pages/include/DynamicBanner';
import api from '../../../api';

const INITIAL_VISIBLE_ROWS = 10; 

const CourseIntergrate = () => {
  const [courseData, setCourseData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    const fetchCourseData = async () => {
      try {
    
        const response = await api.get("/api/sitepages/academic/courses-which-integrate");
   
        const rawData = response.data.data || response.data; 

        const rawImages = rawData?.banner_images || [];
        const formattedImages = rawImages.map(img =>
          img && !img.startsWith("/") ? `/${img}` : img
        );
         const rawmobImages = rawData?.mobile_banner_images|| [];
        const formattedmobImages = rawmobImages.map(img =>
          img && !img.startsWith("/") ? `/${img}` : img
        );

        const formattedData = {
          banner: {
            heading: rawData.banner_title || 'Crosscutting Issues',
            images: formattedImages,mobileeimages:formattedmobImages,
          },
          main_heading: rawData.page_title || "Courses which Integrate Crosscutting Issues",
          sections: rawData.sections || [],
        };
        
        setCourseData(formattedData);
        setIsLoading(false);

      } catch (err) {
        console.error("Error fetching Course Integrate data:", err);
        setError("Failed to load course integration data.");
        setIsLoading(false);
      }
    };

    fetchCourseData();
  }, []);

  const toggleSection = (sectionIndex) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionIndex]: !prev[sectionIndex]
    }));
  };

  if (isLoading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  if (error || !courseData) {
    return <div className="alert alert-danger text-center p-5">{error}</div>;
  }

  const bannerData = courseData.banner || {};
  const mainHeading = courseData.main_heading || "Courses which Integrate Crosscutting Issues";
  const sections = courseData.sections || []; 

  return (
    <>
      {/* 1. Dynamic Banner (Now explicitly using DynamicBanner) */}
      {bannerData.images.length > 0 && (
        <DynamicBanner
          title={bannerData.heading}
          bgImage={bannerData.images}
          bgImageMobile={bannerData.mobileeimages}
        />
      )}

      {/* 2. Main Content Section */}
      <section className="pt_5 course-intergrate-section">
        <div className="container">
          <div className="row">
            <div className="sec-title text-center">
              <h2>{mainHeading}</h2>
            </div>

            {/* Render all dynamic sections/tables */}
            {sections.map((section, sectionIndex) => (
              <DynamicTableSection
                key={sectionIndex}
                section={section}
                sectionIndex={sectionIndex}
                isExpanded={expandedSections[sectionIndex]}
                toggleSection={toggleSection}
              />
            ))}
            
          </div>
        </div>
      </section>
    </>
  );
};

// Helper Component to render each individual table section dynamically
const DynamicTableSection = ({ section, sectionIndex, isExpanded, toggleSection }) => {
  const { title, columns, rows, read_more_text } = section;

  const hasReadMore = rows.length > INITIAL_VISIBLE_ROWS;
  const visibleRows = isExpanded ? rows : rows.slice(0, INITIAL_VISIBLE_ROWS);
  
  // Ensure we have rows to display before rendering the whole section
  if (!rows || rows.length === 0) return null;

  return (
    <div className="col-12 ">
      <div className="mb-3 text-center">
        <h2>{title}</h2>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              {/* Render Column Headers */}
              {columns.map((column, colIndex) => (
                <th key={colIndex}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody style={{ textAlign: 'center' }}>
            {/* Render Visible Rows */}
            {visibleRows.map((row, rowIndex) => (
              <tr key={`${sectionIndex}-${rowIndex}`}> 
                {/* Render Cells */}
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Read More/Read Less Button */}
      {hasReadMore && (
        <div className="text-center mt-3">
          <button
            className="btn btn-about mb-5"
            onClick={() => toggleSection(sectionIndex)}
            aria-expanded={isExpanded}
          >
            {isExpanded ? 'Read Less' : (read_more_text || 'Read More')}
          </button>
        </div>
      )}
    </div>
  );
};

export default CourseIntergrate;